import "core-js/fn/array/index"
import React from "react"
import { HashRouter, withRouter } from "react-router-dom"

import NotificationContainer from "./v1/components/NotificationContainer"
import InitialDataLoader from "./v1/components/InitialDataLoader"

import Appcues from "./v1/components/Config/Appcues"
import Router_v1 from "./Router_v1"
import Router_v2 from "./Router_v2"
import { getSubdomain } from "./v1/components/Config/StylesheetInjector"
import SplitClient, { CARADVISE_2_NAVIGATION, V1 } from "./v1/components/Config/SplitClient"
import { APP_NAME } from "./shared_component/constants/common"
import {
  shouldStartNewSession,
  startNewSession
} from "./shared_component/utils/sessionManagerHelper"
import { connect } from "react-redux"

const WrappedAppcues = withRouter(Appcues)

class Router extends React.Component {
  state = {
    isCarAdviseNavigation: null
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    const isNavigation = await SplitClient.getTreatments(
      [CARADVISE_2_NAVIGATION],
      this.props.user,
      {
        sub_domain: getSubdomain(),
        app_name: APP_NAME
      }
    )

    if (isNavigation && this.state.isCarAdviseNavigation !== isNavigation[CARADVISE_2_NAVIGATION]) {
      this.setState({
        isCarAdviseNavigation: isNavigation && isNavigation[CARADVISE_2_NAVIGATION]
      })
    }

    if (shouldStartNewSession()) {
      const params = {
        version: isNavigation && isNavigation[CARADVISE_2_NAVIGATION]
      }
      startNewSession(params)
    }
  }

  render() {
    const { isCarAdviseNavigation } = this.state
    return (
      <>
        <NotificationContainer />
        <HashRouter>
          <WrappedAppcues>
            <InitialDataLoader />
            {isCarAdviseNavigation && isCarAdviseNavigation === V1 ? (
              <Router_v1 />
            ) : (
              <Router_v2 isCarAdviseNavigation={isCarAdviseNavigation} user={this.props.user} />
            )}
          </WrappedAppcues>
        </HashRouter>
      </>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  }
}
export default connect(mapStateToProps)(Router)
